import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="py-14 px-6 md:px-12 max-w-4xl mx-auto text-center" data-id="element-29">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="flex flex-col items-center" data-id="element-30">
        <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-10" data-id="element-31">
          Descubre la ciencia detrás de la arquitectura facial
        </h3>

        <a href="https://go.hotmart.com/E101139832A?ap=2e42" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-5 text-base md:text-lg font-medium text-white transition-all duration-300 bg-charcoal hover:bg-charcoal-light overflow-hidden rounded-sm no-underline" data-id="element-32">
          <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-33"></div>
          <span className="relative flex items-center gap-3" data-id="element-34">
            Ver la presentación del método de Yoga Facial
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-35" />
          </span>
        </a>

        <p className="mt-6 text-sm font-sans text-charcoal-light/70 flex items-center gap-2" data-id="element-36">
          <span className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-37"></span>
          Presentación disponible por tiempo limitado
        </p>
      </motion.div>
    </section>;
}